export default __webpack_public_path__ + "static/media/icon-arrow-right.8fefae28.svg";